import { ToastContainer, toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import { isBefore } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState, useRef } from 'react';
import { Cookies } from 'react-cookie';
import { ExportData } from '../../Exports/Export';
import { ClearSession } from '../../Common/Common'
import * as XLSX from 'xlsx';
import Loader from "../../Layout/Loader";
import PickupMasterReportTable from './PickupMasterReportTable';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, Table, TextField } from '../../../../node_modules/@mui/material/index';
import Footer from '../../Layout/FooterComponent';
import { Table2 } from '../../Common/userlocationtable';
import { PickupMasterTable } from '../../Common/PickupMasterDynamictable';

const cookies = new Cookies();


const PickupMasterReportForm = () => {

    useEffect(() => {
        document.title = 'PickupMaster Report'
    }, [])

    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [ColoredRow, setColoredRow] = useState('');
    const [tableData, setTableData] = useState([])
    const [eventCodeDropdown, setEventCodeDropdown] = useState([])
    const [VenueCodeDropdown, setVenueCodeDropdown] = useState([])
    const [CustodianDropdown, setCustodianDropDown] = useState([])
    const [StatusCodeDropdown, setStatusCodeDropdown] = useState([])
    const [userCodeDropdown, setUserCodeDropdown] = useState([])
    const [DistrictDropdown, setDistrictDropdown] = useState([])
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const navigate = useNavigate()
    
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [SessionClear, SetSessionClear] = useState(false);

    let baseUrl;
    if (window.location.hostname.indexOf("react.") >= 0) {
        baseUrl = `${window.location.protocol}//${window.location.host}/${window.location.pathname.split('/')[1]}`;
    } else {
        baseUrl = `${window.location.protocol}//${window.location.host}`;
    }

    const [formData, setFormData] = useState({
        EventCode: '',
        VenueCode: '',
        CustodianCode: '',
        StatusCode: '',
        UserCode: '',
        District: '',
        TrunkId: '',
        fromDate: '',
        toDate: '',
        SearchFieldValue: "",
        PageSize: "",
        SearchText: "",
        StartValue: ''
    });
    const inputRefs = useRef([]);
   


    const filterFutureDates = (date) => {
        return isBefore(date, new Date());
    }


    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';


    const handleClear = () => {
        setFormData({
            EventCode: '',
            VenueCode: '',
            CustodianCode: '',
            StatusCode: '',
            UserCode: '',
            District: '',
            TrunkId: '',
            SearchFieldValue: "",
            PageSize: "",
            SearchText: "",
            StartValue: ''
        });
        setTableData([])


        //setFromDate('')



        setEdit(false)
        setColoredRow(null)
    }
    const EventDropdownList = async () => {


        let data = { Token, LoginUserCode }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeDropdown(res.eventList);
                //setFormData({ ...formData, EventCode: res.EventCodeList[0].eventCode.eventName })
            }).catch((err) => console.log(err));

    };
    const DistrictDropdownList = async (eventCode) => {


        let data = {
            Token, LoginUserCode, eventCode,  Type: 'GetDistrict'
        }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setDistrictDropdown(res.district);
                //setFormData({ ...formData, EventCode: res.EventCodeList[0].eventCode.eventName })
            }).catch((err) => console.log(err));

    };
    const handleClick = async (trukId) => {
        window.open(`/TrackingTrunk?trunK_ID=${trukId}`)

    }
    const CustodianDropdownList = async (eventCode, District) => {


        let data = { Token, LoginUserCode, eventCode, District }
        await fetch('/api/MasterController/GetCustodian',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setCustodianDropDown(res.custodianList
                );

            }).catch((err) => console.log(err));

    };
    const StatusCodeDropdownList = async () => {


        let data = { Token, LoginUserCode }
        await fetch('/api/ReportController/GetStatus',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setStatusCodeDropdown(res.statusList);

            }).catch((err) => console.log(err));

    };
    const getTrackingData = (TrunkID) => {
        window.open(baseUrl + '/TrackingTrunk?TrunkID=' + TrunkID, '_blank');
        console.log(TrunkID,"TrunkIDForTracking")
    };

    const userCodeDropdownList = async () => {
        let Condition = " And UserGroupID In(3,4)";
        let TextPart = "UserName"
        let ValuePart = "UserCode"
        let TableName = "UserMaster"
        let data = { Token, LoginUserCode, Condition, TextPart, ValuePart, TableName }
        await fetch('/api/User/BindDropDownList',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setUserCodeDropdown(res.dropDownList);
                }
                else if (res.message === "EXPIRED") {
                    ClearSession();

                }
                else if (res.message !== "") {
                    toast.error(res.message, {

                    })
                }

            }).catch((err) =>
                toast.error(err.message, {
                    position: 'top-center'
                })
            );

    };

    
    const VenueDropdownList = async (eventCode,district) => {


        let data = {
            Token, LoginUserCode, eventCode, district, Type: 'GetVenue'
        }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setVenueCodeDropdown(res.venueList);
                //setFormData({ ...formData, EventCode: res.EventCodeList[0].eventCode.eventName })
            }).catch((err) => console.log(err));

    };

    const handleSubmit = async (CurrentPage) => {
        setIsLoading(true)
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let data = {
            ...formData, Token, LoginUserCode, Source, FromDate: document.getElementById('txtfromDate').value, toDate: document.getElementById('txtDateTo').value,
            Type: 'S',
            PageIndex: `${PageIndex}`

        }
        await fetch(`/api/ReportController/PickUpMasterReport`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.Status === "SUCCESS") {
                setTableData(responseData);
               

            } else if (responseData.message === "EXPIRED") {
                navigate("/login")

                SetSessionClear(true);
            }

            else if (responseData.Status === "ERROR") {
                toast.error(responseData.Message, {

                })
               setTableData([])            }
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err.message, {

            })
            setIsLoading(false)
        }, [])
    };




    const handleChange1 = (event, value) => {
        handleSubmit(value)
    };


    const handleDownloadExcel = async () => {
        const requestBody = {
            ...formData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        try {
            const response = await fetch('/api/ReportController/PickUpMasterReport', {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: requestHeaders,
            });
            const res = await response.json();
            if (res.Status === "SUCCESS") {

                const workbook = XLSX.utils.book_new();
                let worksheet = XLSX.utils.aoa_to_sheet([
                    res?.HeadersValue
                    ,
                    ...res?.Data?.map((records) =>
                        res.HeadersKey?.map((data, i) =>
                            records[data]
                        )
                    ),
                ]);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PickUpMasterReport.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return
            }
        } catch (err) {
            toast.error(err.message, {

            });
        }


    };
    useEffect(() => {
        inputRefs.current['ddlEventCode'].children[0].children[0].focus()
        EventDropdownList()
        StatusCodeDropdownList()
        userCodeDropdownList()
    }, [])

    useEffect(() => {

    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Pickup Master Report'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Event<span className="Required">*</span></label>
                                            <Autocomplete
                                             
                                                value={eventCodeDropdown?.find((item) => item.eventCode === formData.EventCode) || null}
                                                onChange={(event, newValue) => {
                                                    setFormData({ ...formData, EventCode: newValue?.eventCode ||'' });
                                                    DistrictDropdownList(newValue?.eventCode || '');
                                                    CustodianDropdownList(newValue?.eventCode || '','');
                                                    VenueDropdownList(newValue?.eventCode || '', '');
                                                }}
                                                options={eventCodeDropdown || []}
                                                getOptionLabel={(option) => ` ${option.eventName}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        style={{ backgroundColor: 'white' }}
                                                        ref={ref => (inputRefs.current['ddlEventCode'] = ref)}
                                                        placeholder="Event"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['txtfromDate'].input.focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                     
                                    </div>

                                    <div className="col-lg-2  col-md-4 col-sm-6 ">
                                        <div className="fields ">
                                            <label className="form-label">Date </label>

                                            <DatePicker
                                                selected={FromDate}
                                                ref={ref => (inputRefs.current['txtfromDate'] = ref)}
                                                id='txtfromDate'
                                                className="form-control"
                                                placeholderText='From Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => setFromDate(date)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtDateTo'].input.focus();
                                                    };
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <DatePicker
                                                selected={ToDate}
                                                ref={ref => (inputRefs.current['txtDateTo'] = ref)}
                                                id='txtDateTo'
                                                className="form-control"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => setToDate(date)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlDistrict'].children[0].children[0].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">District</label>
                                            <Autocomplete
                                                value={DistrictDropdown?.find((item) => item.districtCode === formData.DistrictCode) || null}
                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, DistrictCode: newValue?.districtCode || '' })
                                                    CustodianDropdownList(formData.EventCode, newValue?.districtCode || '');
                                                    VenueDropdownList(formData.EventCode,newValue?.districtCode || '');
                                                }}
                                                
                                                options={DistrictDropdown || []}
                                                getOptionLabel={(option) => ` ${option.districtName}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        ref={ref => (inputRefs.current['ddlDistrict'] = ref)}
                                                        id='ddlDistrict'
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="District"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['ddlCustodianCode'].children[0].children[0].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Custodian</label>
                                            <Autocomplete
                                                value={CustodianDropdown?.find((item) => item.custodianCode === formData.CustodianCode) || null}

                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, CustodianCode: newValue?.custodianCode || '' })

                                                }}
                                                options={CustodianDropdown || []}
                                                getOptionLabel={(option) => option.custodianName || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        style={{ backgroundColor: 'white' }}
                                                        ref={ref => (inputRefs.current['ddlCustodianCode'] = ref)}
                                                        id='ddlCustodianCode'
                                                        placeholder="Custodian"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['ddlVenueCode'].children[0].children[0].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">

                                        <div className="fields">
                                            <label className="form-label"> Venue</label>
                                            <Autocomplete
                                                // value={formData.VenueCode}
                                                value={VenueCodeDropdown?.find((item) => item.venueCode === formData.VenueCode) || null}
                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, VenueCode: newValue?.venueCode || '' })

                                                }}
                                                options={VenueCodeDropdown || []}
                                                getOptionLabel={(option) => option.venueName || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        style={{ backgroundColor: 'white' }}
                                                        ref={ref => (inputRefs.current['ddlVenueCode'] = ref)}
                                                        id="ddlVenueCode"
                                                        placeholder="Venue"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['ddlStatusCode'].focus()
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                       
                                    </div>
                                   
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Status</label>
                                            <select
                                                ref={ref => (inputRefs.current['ddlStatusCode'] = ref)}
                                                id="ddlStatusCode"
                                                className="form-select"
                                                value={formData.StatusCode}
                                                onChange={(e) => setFormData({ ...formData, StatusCode: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlUserCode'].children[0].children[0].focus();
                                                    };
                                                }}
                                            >
                                                <option value=''>Please Select Status </option>
                                                {
                                                    StatusCodeDropdown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.statusCode}>{item.statusName}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                   
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">User</label>
                                            <Autocomplete
                                             
                                                value={userCodeDropdown?.find((item) => item.valuePart === formData.UserCode) || null}
                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, UserCode: newValue?.valuePart || '' })

                                                }}
                                                options={userCodeDropdown || []}
                                                getOptionLabel={(option) => ` ${option.textPart}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        style={{ backgroundColor: 'white' }}
                                                        ref={ref => (inputRefs.current['ddlUserCode'] = ref)}
                                                        id="ddlUserCode"
                                                        placeholder="User"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['txtTrunkId'].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>

                                 

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Trunk ID</label>
                                            <input
                                                ref={ref => (inputRefs.current['txtTrunkId'] = ref)}
                                                id="txtTrunkId"
                                                type="text"
                                                className="form-control"
                                                placeholder="Trunk ID"
                                                autoComplete="off"
                                                maxLength='15'
                                                name='TrunkId'
                                                value={formData.TrunkId}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, TrunkId: e.target.value })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn info" onClick={handleSubmit}>
                                                <i className="fa fa-search" />  Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className='heading-box1 d-block d-sm-flex'>
                                <div className="heading">
                                    <h6 className='m-0 mb-2 mb-sm-0 font-weight-bold text-primary' style={{ fontSize: "1rem" }}>{`${(tableData.length !== 0) ? 'Total Records : ' + tableData?.TotalRecord : 'No Record Found'}`}</h6>
                                </div>
                            </div>
                                {tableData.length !== 0 ?
                                <PickupMasterTable
                                    tableData={tableData}
                                    handleClick={handleClick}
                                        currentPageNo={currentPageNo}
                                        handleChange1={handleChange1}
                                    /> : <></>}
                            
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer theme='colored' />
            {SessionClear ? <ClearSession /> : <></>}
            <Footer />
        </>
    )
}
export default PickupMasterReportForm






